export const userDisplayName = (displayName) => {
  return (
    displayName
      ?.match(/\b(\w)/g)
      .join("")
      .toUpperCase() || ""
  );
};
export const getChipColor = (value) => {
    if (value.includes('progress') || value.includes('Progress')) return 'warning';
    if (value.includes('Applied'))   return 'info';
    if (value.includes('Completed')) return 'success';
    if (value.includes('Cancelled') || value.includes('Rejected')) return 'error';
    return 'default';
}
